import styled from '@emotion/styled';

export const Finder = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 16px;
  padding-bottom: 24px;
`;

export const Img = styled.img`
  width: 100%;
  height: 440px;
  object-fit: cover;
`;
